import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { CdiLinesComponent } from "../cdi-lines/cdi-lines.component";
import { ConfirmationService } from "primeng/api";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { CommonModule, DatePipe } from "@angular/common";
import buildQuery from "odata-query";
import { CDILinesDto } from "../../../core/models/cdi/CDILinesDto";
import { OcrInvoiceMatchingNotes } from "../../../core/models/cdi/CDINotes";
import { CopyCdiLinesRequestDto } from "../../../core/models/cdi/copyCdiLinesRequestDto";
import { CustomerPaymentMethodDto } from "../../../core/models/orders/customerPaymentMethodDto";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { GetExtisingPOIdRequest } from "../../../core/models/orders/getExtisingPOIdRequest";
import { PoEmailData } from "../../../core/models/orders/PoEmailData";
import { PurchaseOrderIdDto } from "../../../core/models/orders/purchaseOrderIdDto";
import { PrintPurchaseOrderDto } from "../../../core/models/orders/purchaseOrderLine";
import { SaleOrderHeaderAddressDto } from "../../../core/models/orders/saleOrderHeaderAddressDto";
import { SaleOrderLineAddressDto } from "../../../core/models/orders/saleOrderLineAddressDto";
import { SaleOrderResponseDto } from "../../../core/models/orders/saleOrderResponseDto";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { CDISummaryService } from "../../../core/services/cdi-resolution-summary.service";
import { ClientDetailsService } from "../../../core/services/client-details.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { SidebarService } from "../../../core/services/sidebar.service";
import { OrderSummaryLineItemsComponent } from "../../orders/components/order-summary-line-items/order-summary-line-items.component";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ExchangeRatesDto } from "../../../core/models/shared/exchangeRateDto";
import { Address } from "../../../core/models/shared/address";
import { CdiHeaderComponent } from "../cdi-header/cdi-header.component";
import { CdiNotesComponent } from "../cdi-notes/cdi-notes.component";
import { SamplepoCopyLinesComponent } from "../../samplePo/components/samplepo-copy-lines/samplepo-copy-lines.component";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { SamplepoSummaryService } from "../../../core/services/samplepo-summary.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-cdi-resolution-summary",
  templateUrl: "./cdi-resolution-summary.component.html",
  styleUrls: ["./cdi-resolution-summary.component.scss"],
  providers: [DatePipe, ConfirmationService],
  imports: [
    CommonModule,
    OrderSummaryLineItemsComponent,
    TableModule,
    NgxExtendedPdfViewerModule,
    CdiHeaderComponent,
    CdiNotesComponent,
    SamplepoCopyLinesComponent,
    CdiLinesComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class CdiResolutionSummaryComponent implements OnInit {
  @Input() CDIResolutionNumber = "";
  @Input() poNumber = "";
  @Input() saleOrderId = "";
  @Input() cdiRecId = 0;
  isDisableSubmit = false;
  poJournalPdf = "";
  line?: CDILinesDto;
  cdiSummaryForm!: FormGroup;
  vendorName = "";
  vendorNumber = "";
  cdi = 0;
  reason = "";
  netTotal = 0;
  cdiActionVal = "";
  recId = "";
  tableId = "";
  jobNameHeader = "";
  customerName = "";
  linesVendorNumber = "";
  tax = 0;
  freight = 0;

  @Input() saleOrderIdFromModal = "";
  @Input() isFromIRScreen = false;
  @Output() clearShipToEvent = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  collapseHeaderStatus = false;
  expandHeaderStatus = true;
  collapseHeaderHeading = "Collapse all";
  quickQuoteValue = "";
  @ViewChild("cdiNotes", { static: false })
  cdiNotes!: CdiNotesComponent;

  collapseNotesStatus = true;
  expandNotesStatus = false;
  collapseNotesHeading = "Collapse all";

  // saleOrderForm!: FormGroup;
  shipDate = "";
  inHandDate = "";
  salesOrderLine: SaleOrderLineAddressDto[] = [];
  showSmallLoader = false;
  pdfSmallLoader = false;
  salesOrderStatusD365 = "";
  approvalStatusD365 = "";
  applyFeeCardStatus = "";
  currencyConversion!: ExchangeRatesDto;
  subTotal = "";
  net = "";
  gp = 0;
  commission = 0;
  gpPercentage = 0;
  orderTotal = 0;
  netGp = 0;
  netGpPercentage = 0;
  percentageSign = "%";
  showAddress = false;
  loaderStatus = true;
  foreignCurrency = "";
  countryRegionList: AddressCountryRegion[] = [];
  customerBillToObject!: ClientSearchList;
  shippingProductsList: ShippingMethod[] = [];
  customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  hiddenShipDate = true;
  hiddenInHandDate = true;
  applyCreditCardStatus = true;
  addressFieldStatus = true;
  estimatedTaxStatus = true;
  estimatedFreightStatus = true;
  customerLists: Address[] = [];
  selectedAccountNumber = "";
  creditfee = 0;
  oldEstimatedTax = 0;
  estimatedTax = 0;
  recommendedTax = 0;
  oldEstimatedFreight = 0;
  estimatedFreight = 0;
  releasedProductsList: ReleasedProduct[] = [];
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  bcProjectId = "";
  bacProjectId = "";
  editHeaderStatus = false;
  updateButtonValidation = true;
  //brandingConsultantObject: any;
  shipDateCurrentdate = new Date();
  inHandDateCurrentdate = new Date();
  displayModal = false;
  freightChargeAmount = 0;
  bacUserDefaultSelectionId = "";
  salesOrderLines: SaleOrderLineAddressDto[] = [];
  purchaseOrderIdList: PurchaseOrderIdDto[] = [];
  public customerVendor$ = new Subject<string>();
  userPersonnelNumber!: string;
  smallLoader = false;
  displayEmailInvoiceModal = false;
  displaySidebar = false;
  isCustomerPoRequiredField = false;
  avaiableCredit = 0;
  getAvailableCreditBtnStatus = false;
  poExistFlag = false;
  clientDisplayModal = false;
  customerId = "";
  shiftToAddressList!: Address[];
  headerAddress!: Address;
  bcPersonnelNumber = "";
  netCommissionStatus = false;
  printPdfModal = false;
  saleOrderModalStatus = false;
  isSaleOrderLineSync!: SaleOrderLineAddressDto[];
  isSaleOrderLineConfirmStatus = false;
  salesOrderLineDistinct: SaleOrderLineAddressDto[] = [];
  purchaseOrderLine: PrintPurchaseOrderDto[] = [];
  openPrinfPdfFlag = false;
  userObject!: GetUserDto;
  freightChargesDisplayModal = false;
  poEmailDisplayModal = false;
  poEmailData: PoEmailData = {} as PoEmailData;
  userBlockedFromEdit = false;
  orderTotalD365 = 0;
  subtotalForCreditLimitCheck = 0;
  sumOfSellTotal = 0;
  documentIDD365 = "";
  unmatched = 0;
  serviceFeeFromD365 = 0;

  formErrors: Record<string, string> = {
    jobName: "",
    brandingConsultant: "",
    methodOfPayment: "",
    customerId: "",
    shipDate: "",
    inHandsDate: "",
    addressSelectionName: "",
    countryRegionIdD365: "",
    customerPONumber: "",
    deliveryNameD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    jobName: {
      required: "Job name is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 300 characters.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 50 characters.",
    },
    accountsCoordinator: {
      required: "Accounts coordinator is required.",
    },
    methodOfPaymentHeader: {
      required: "Payment method is required.",
    },
    customerId: {
      required: "Client account is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandsDate: {
      required: "In-Hands date is required.",
    },
    addressSelectionName: {
      required: "Delivery is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    customerPONumber: {
      required: "Client PO Number is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  @ViewChild("linesComponent", { static: false })
  linesComponent!: CdiLinesComponent;

  cdiNotesGridListing: OcrInvoiceMatchingNotes[] = [];
  cdiLinesGridListing: CDILinesDto[] = [];

  displayCopyLineModel = false;

  lazyLoadEvent: TableLazyLoadEvent = {
    filters: {},
    first: 0,
    globalFilter: null,
    multiSortMeta: undefined,
    rows: 20,
    sortField: undefined,
    sortOrder: 1,
  };

  @ViewChild("copyline", { static: false })
  copyline!: SamplepoCopyLinesComponent;

  invoiceEmailListing: {
    jniSubTotal: string;
    vendorSubTotal: string;
    diff: number;
    vendorTax: number;
    vendorFrt: number;
  }[] = [];
  isCollapsed = false;
  hideButtonsOnPageLoad = true;
  salesOrderHeaderData!: SaleOrderHeaderAddressDto;
  saleOrderData = {} as SaleOrderResponseDto;

  constructor(
    private _cdiSummaryService: CDISummaryService,
    private _loaderService: LoaderService,
    private _toastrService: JniToastrService,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _samplePOSummaryService: SamplepoSummaryService,
    private _orderSummaryService: OrderSummaryService,
    private renderer: Renderer2,
    private _clientDetailsService: ClientDetailsService,
    private _samplepoListingService: SamplepoListingService,
    public datepipe: DatePipe,
    private _dataService: SidebarService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.cdiRecId = params["id"];
    });
    this.initializeForm();
  }

  ngOnInit(): void {
    this._dataService.setSidebarState(!this.isCollapsed);
    this.getCDINotes(this.cdiRecId);
    this.getCdiSummary(this.cdiRecId);
  }

  private initializeForm() {
    this.cdiSummaryForm = this._formBuilder.group({
      lines: this._formBuilder.group({
        id: [0],
        poNumber: ["", Validators.required],
        vendorSku: ["", Validators.required],
        description: [""],
        unmatch: [""],
        qty: [""],
        net: [""],
        netTotal: [""],
        sell: [""],
        sellTotal: [""],
        netGp: [""],
        status: [""],
        notes: [],
      }),
      linesArray: this._formBuilder.array([]),
    });
  }

  getCDINotes(recId: number) {
    this._loaderService.setLoaderState(true);
    this._cdiSummaryService
      .getCDINotes(recId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.cdiNotesGridListing = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
    // this.cdiNotesGridListing = [{
    //   id: 1,
    //   salesOrderId: this.saleOrderId,
    //   type: "AP",
    //   attachmentRecId: "",
    //   purchaseOrderId: this.poNumber,
    //   description: "Extra Item-Item 262151 short by 2 Qty",
    //   note: "Extra Item-Item 262151 short by 2 Qty",
    //   portalKey: "",
    //   restriction: "",
    //   status: "",
    //   statusCode: 1,
    //   message: ""
    // },
    // {
    //   id: 2,
    //   salesOrderId: this.saleOrderId,
    //   type: "AP",
    //   attachmentRecId: "",
    //   purchaseOrderId: this.poNumber,
    //   description: "Approve to match vendor net cost",
    //   note: "Approve to match vendor net cost",
    //   portalKey: "",
    //   restriction: "",
    //   status: "",
    //   statusCode: 1,
    //   message: ""
    // },
    // {
    //   id: 3,
    //   salesOrderId: this.saleOrderId,
    //   type: "AP",
    //   attachmentRecId: "",
    //   purchaseOrderId: this.poNumber,
    //   description: "Additional CDI need e-mail link example",
    //   note: "Additional CDI need e-mail link example",
    //   portalKey: "",
    //   restriction: "",
    //   status: "",
    //   statusCode: 1,
    //   message: ""
    // }]
  }

  // getCDILines(cdiNumber: string) {
  //   this._loaderService.setLoaderState(true);
  //   this._cdiSummaryService
  //     .getCDILineDetails(cdiNumber)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this._loaderService.setLoaderState(false);
  //         if (res.data) {
  //           this.cdiLinesGridListing = res.data;
  //         }
  //       },
  //       error: (res) => {
  //         this._loaderService.setLoaderState(false);
  //       }
  //     });
  //   // this.cdiLinesGridListing = [
  //   //   {
  //   //     id: 1,
  //   //     poNumber: this.poNumber,
  //   //     vendorSku: 'RTIC-COFFEEW',
  //   //     description: 'Setup - Laser Engrave - 2 sides',
  //   //     deliverRemainderD365: 0,
  //   //     orderedPurchaseQuantityD365: 2,
  //   //     unmatch: 2,
  //   //     qty: 2,
  //   //     net: 45,
  //   //     netTotal: 120,
  //   //     sell: 60,
  //   //     sellTotal: 120,
  //   //     netGp: 22.5,
  //   //     status: 'Pending',
  //   //     notes: []
  //   //   },
  //   //   {
  //   //     id: 2,
  //   //     poNumber: this.poNumber,
  //   //     vendorSku: 'RTIC-COFFEEW',
  //   //     description: 'Domestic Drop ship fee',
  //   //     deliverRemainderD365: 0,
  //   //     orderedPurchaseQuantityD365: 2,
  //   //     unmatch: 0,
  //   //     qty: 85,
  //   //     net: 2.8,
  //   //     netTotal: 297.5,
  //   //     sell: 3.5,
  //   //     sellTotal: 297.5,
  //   //     netGp: 17.5,
  //   //     status: 'Add to freight',
  //   //     notes: []
  //   //   }
  //   // ];
  // }

  refreshGrid() {
    this.getCdiLines(this.CDIResolutionNumber);
    this.linesComponent.uncheckAll();
  }

  closeModalDialog() {
    this.displayCopyLineModel = false;
  }

  // clearLinesForm() {
  //   this.cdiSummaryForm.get('lines')?.reset({
  //     itemNumberD365: '',
  //     externalItemNumberD365: '',
  //     orderedPurchaseQuantityD365: '',
  //     rsmFirmD365: false,
  //     purchasePriceD365: 0,
  //     // requestedShippingDateD365: this.shippingDate,
  //     // requestedDeliveryDateD365: this.inHandsDate,
  //     lineAmountD365: 0,
  //     lineDescriptionD365: '',
  //     factoryNotesD365: '',
  //     netConversion: '',
  //     netConversionTotal: '',
  //     lineNumberD365: this.getMaxLineNumber(),
  //     purchaseOrderNumberD365: ''
  //   });
  // }

  saveAndUpdateCdiGrid(cdiLine: CDILinesDto) {
    if (!cdiLine.id) {
      const cdiLineArray = [];
      cdiLine.poNumber = this.poNumber;
      cdiLineArray.push(cdiLine);
      const addUpdateCDiLineDto = {
        cdiLine: cdiLineArray,
      };
      this._cdiSummaryService.addCdiLine(addUpdateCDiLineDto).subscribe({
        next: res => {
          if (res.data?.cdiLine) {
            this.linesComponent.uncheckAll();
            this.clearLinesForm();
            this._loaderService.setLoaderState(false);
            this._toastrService.success("Success", "Line Added Successfully");
            // this.getSamplePOSummary(this.samplePONumber);
            // this.getSamplePOSummaryDelete(this.samplePONumber);
          } else {
            this._loaderService.setLoaderState(false);
            this._toastrService.error("Error", "Error Adding Lines");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error("Error", "Error Adding Lines");
        },
      });
    } else {
      const addUpdateCdiLineDto = {
        cdiLine: cdiLine,
      };
      this._cdiSummaryService.updatePOLine(addUpdateCdiLineDto).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.clearLinesForm();
          //this.getSamplePOSummary(this.samplePONumber);
          if (res.status.toLowerCase() != "success") {
            this._toastrService.error(
              "Error",
              res.message || "Failed To Update PO Line"
            );
            return;
          }

          if (res.data) {
            this._toastrService.success(
              "Success",
              res.message || "Line Updated Successfully"
            );
          } else {
            this._loaderService.setLoaderState(false);
            this._toastrService.error(
              "Error",
              res.message || "Error Updating Lines"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error Adding Lines"
          );
        },
      });
    }
  }

  clearLinesForm() {
    this.cdiSummaryForm.get("lines")?.reset({
      id: 0,
      poNumber: "",
      vendorSku: "",
      description: "",
      unmatch: "",
      qty: 0,
      net: 0,
      netTotal: 0,
      sell: 0,
      sellTotal: 0,
      netGp: 0,
      status: "line.status",
      notes: [],
    });
  }

  showCopyLineModalDialog(selectCdiLines: CDILinesDto[]) {
    if (selectCdiLines && selectCdiLines?.length > 0) {
      this.copyCdiLine(selectCdiLines);
    } else {
      this.displayCopyLineModel = true;
      this.copyline.getAllSamplepoListingData(this.lazyLoadEvent);
    }
  }

  copyCdiLine(selectCdiLines: CDILinesDto[]) {
    this._loaderService.setLoaderState(true);
    const addUpdateCdiLineDto: CopyCdiLinesRequestDto = {
      cdiLine: selectCdiLines,
      cdiNumber: this.CDIResolutionNumber,
    };
    this._cdiSummaryService.copyCdiLines(addUpdateCdiLineDto).subscribe({
      next: res => {
        if (res.data) {
          this.getCdiLines(this.CDIResolutionNumber);
          this._loaderService.setLoaderState(false);
          this._toastrService.success("Success", "Copy Line Successfully");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("Error", "Error Copying Lines");
      },
    });
  }

  getCdiSummary(recId: number) {
    this._cdiSummaryService
      .getCDISummary(recId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.jobNameHeader = res.data.jobName;
            this.customerName = res.data.customerNameD365;
            this.vendorName = res.data.vendorNameD365;
            this.vendorNumber = res.data.vendorAccountD365;
            this.cdi = res.data.id;
            this.reason = res.data.reasonD365;
            this.poJournalPdf = res.data.documentURLD365;
            this.cdiActionVal = res.data.rsmJNICDIActionD365;
            this.recId = res.data.recId1D365.toString();
            this.tableId = res.data.tableId1;
            this.saleOrderId = res.data.salesOrderD365;
            this.poNumber = res.data.purchaseOrderD365;
            this.documentIDD365 = res.data.documentIDD365;
            this.tax = res.data.taxD365;
            this.freight = res.data.freightD365;
            this.unmatched = res.data.unmatchedD365;
            this.isDisableSubmit =
              this.cdiActionVal === "Pending" ? false : res.data.submitStatus;
            this.invoiceEmailListing = [
              {
                jniSubTotal: res.data.jnipoD365.toString(), //'Subtotals :',
                vendorSubTotal: res.data.invoiceTotalD365.toString(), //'$2,157.22',
                diff: this.unmatched || 0, //'$2,157.22',
                vendorTax: res.data.taxD365, //'$54.22',
                vendorFrt: res.data.freightD365,
              },
            ];
            this.getCdiSharePointPdf();
            this.getSaleOrderLinesData();
            this.getSaleOrderHeaderData(this.loaderStatus);
            this.IsUserBlockedFromEdit();
            this.getAllReleaseProduct();
            this.getCDINotes(Number.parseInt(this.recId));
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  private getCdiLines(CDIResolutionNumber: string) {
    this._loaderService.setLoaderState(true);
    this._cdiSummaryService.getCDILineDetails(CDIResolutionNumber).subscribe({
      next: res => {
        res.data = [
          {
            id: 1,
            poNumber: this.poNumber,
            vendorSku: "RTIC-COFFEEW",
            description: "Setup - Laser Engrave - 2 sides",
            deliverRemainderD365: 0,
            orderedPurchaseQuantityD365: 2,
            unmatch: 2,
            qty: 2,
            net: 45,
            netTotal: 120,
            sell: 60,
            sellTotal: 120,
            netGp: 22.5,
            status: "Pending",
            notes: [],
          },
          {
            id: 2,
            poNumber: this.poNumber,
            vendorSku: "RTIC-COFFEEW",
            description: "Domestic Drop ship fee",
            deliverRemainderD365: 0,
            orderedPurchaseQuantityD365: 2,
            unmatch: 0,
            qty: 85,
            net: 2.8,
            netTotal: 297.5,
            sell: 3.5,
            sellTotal: 297.5,
            netGp: 17.5,
            status: "Add to freight",
            notes: [],
          },
        ];
        this._loaderService.setLoaderState(false);
        // const odataFilter = `?$filter=ID eq '${CDIResolutionNumber}'`;
        // this._orderSummaryService
        //   .GetJNIDeletedRecordsFilter(odataFilter)
        //   .subscribe();
        if (res.data) {
          if (res.data) {
            this.initializeLine(res.data[0]);
            this.initalizeLinesArray(res.data);
            this.cdiLinesGridListing = res.data;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  private initializeLine(line: CDILinesDto) {
    this.line = line;

    if (line) {
      this.cdiSummaryForm.get("lines")?.patchValue({
        id: line.id,
        poNumber: this.poNumber,
        vendorSku: line.vendorSku,
        description: line.description,
        unmatch: line.unmatch,
        qty: line.qty,
        net: line.net,
        netTotal: line.netTotal,
        sell: line.sell,
        sellTotal: line.sellTotal,
        netGp: line.netGp,
        status: line.status,
        notes: line.notes,
      });
    }
  }

  getPOPDF() {
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(this.poNumber)
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            if (res?.data) {
              this.poJournalPdf = res.data;
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  private initalizeLinesArray(lines: CDILinesDto[]) {
    lines.forEach(x => this.addLines(x));
  }

  public addLines(lines: CDILinesDto) {
    const controls = this.cdiSummaryForm.get("linesArray") as FormArray;
    controls.push(this.createLines(lines));
    // this.calculateTotal();
    // this.calculateNetConversionTotal();
  }

  public createLines(lines: CDILinesDto) {
    return this._formBuilder.group({
      id: lines.id,
      poNumber: this.poNumber,
      vendorSku: lines.vendorSku,
      description: lines.description,
      unmatch: lines.unmatch,
      qty: lines.qty,
      net: lines.net,
      netTotal: lines.netTotal,
      sell: lines.sell,
      sellTotal: lines.sellTotal,
      netGp: lines.netGp,
      status: lines.status,
      notes: lines.notes,
    });
  }

  refreshPage(event: boolean) {
    if (event) {
      this.ngOnInit();
    }
  }

  addScollHiddenClass() {
    //if (this.modal) {
    this.renderer.addClass(document.body, "p-overflow-hidden");

    //}
  }

  getSaleOrderLinesData() {
    if (this.saleOrderId) {
      this.smallLoader = true;
      this._orderSummaryService
        .getSaleOrderLinesData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.smallLoader = false;
            const odataFilter = `?$filter=ID eq '${this.saleOrderId}'`;
            this._orderSummaryService
              .GetJNIDeletedRecordsFilter(odataFilter)
              .subscribe();
            if (res.data) {
              if (res.data.length > 0) {
                if (res.data.length > 0) {
                  this.salesOrderLine = res.data.filter(
                    x =>
                      x.salesOrderLine?.purchasePriceD365 != 0 &&
                      (x.salesOrderLine?.purchaseOrderD365 == this.poNumber ||
                        !x.salesOrderLine?.purchaseOrderD365)
                  );
                  this.getPurchaseOrderLine();
                  if (!this.orderTotalD365) {
                    this.calculateSumOfSellTotalBeforeEdit(res?.data);
                  }
                  this.poExistFlag = this.isPOExist();
                  this.getHeaderCalculation();
                  this.calculateSubTotal();
                  this.calculateSumOfSellTotal();
                  this.isSaleOrderLinesConfirm();
                  this.getVendorLineNumber();
                  this.hideButtonsOnPageLoad = false;
                }
                this.saleOrderData.salesOrderLine = res.data.filter(
                  x =>
                    x.salesOrderLine?.purchasePriceD365 != 0 &&
                    (x.salesOrderLine?.purchaseOrderD365 == this.poNumber ||
                      !x.salesOrderLine?.purchaseOrderD365)
                );
              }
            } else {
              this.smallLoader = false;
            }
            if (this.saleOrderModalStatus) {
              this._loaderService.setLoaderState(false);
            } else {
              this._loaderService.setLoaderState(false);
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this.smallLoader = false;
          },
        });
    }
  }

  getVendorLineNumber() {
    if (this.salesOrderLine.length > 0) {
      for (const line of this.salesOrderLine) {
        if (line.salesOrderLine?.vendorDirectDeliveryD365) {
          this.linesVendorNumber = line.salesOrderLine.vendorDirectDeliveryD365;
          break;
        }
      }
    } else {
      this.linesVendorNumber = this.vendorNumber;
    }
  }

  getPurchaseOrderLine() {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.getPurchaseOrderLine(this.saleOrderId).subscribe({
      next: res => {
        if (res.data) {
          this.purchaseOrderLine = res.data;
          if (this.purchaseOrderLine.length > 0) {
            this.openPrinfPdfFlag = true;
          } else {
            this.openPrinfPdfFlag = false;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  calculateSumOfSellTotalBeforeEdit(saleorderline: SaleOrderLineAddressDto[]) {
    if (saleorderline.length > 0) {
      const sumOfSellTotal = saleorderline.reduce((prev: number, next) => {
        return (
          prev +
          (next.salesOrderLine?.sellTotalD365
            ? parseFloat(next.salesOrderLine?.sellTotalD365)
            : 0)
        );
      }, 0);
      this.orderTotal = sumOfSellTotal;
      // this.patchValueInOrderTotal(this.orderTotal);
    }
  }

  // patchValueInOrderTotal(orderTotal: number) {
  //   this.saleOrderForm.patchValue({
  //     estimatedOrderTotals: {
  //       orderTotal: orderTotal
  //     }
  //   });
  // }

  isPOExist() {
    for (const x of this.salesOrderLine) {
      if (x.salesOrderLine?.purchaseOrderD365) {
        return true;
      }
    }
    return false;
  }

  getHeaderCalculation() {
    setTimeout(() => {
      if (
        this.foreignCurrency &&
        this.foreignCurrency.toLowerCase() !== "usd"
      ) {
        this.calculateNetAfterCurrencyConvert();
        this.calculateNetGpAfterCurrencyConvert();
        this.calculateSubtotalCreditForNonUS();
      } else {
        this.calculateNet();
        this.calculateNetGp();
        this.calculateSubtotalCreditForUS();
      }
    }, 0);
  }

  calculateNetAfterCurrencyConvert() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365 === null ||
                    next?.salesOrderLine?.netConversionTotalD365 === 0
                    ? "0"
                    : next?.salesOrderLine?.netConversionTotalD365.toString()
                )
              : parseFloat(
                  !next?.salesOrderLine?.netTotalD365 ||
                    next?.salesOrderLine?.netTotalD365 === 0
                    ? "0"
                    : next?.salesOrderLine?.netTotalD365.toString()
                ))
          );
        },
        0
      );
      this.net = total.toString();
      this.calculateSubtotalsAndNet();
    }
  }

  calculateNetGpAfterCurrencyConvert() {
    if (this.salesOrderLine.length > 0) {
      const netTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365 === null ||
                    next?.salesOrderLine?.netConversionTotalD365 === 0
                    ? "0"
                    : next?.salesOrderLine?.netConversionTotalD365.toString()
                )
              : parseFloat(
                  !next?.salesOrderLine?.netTotalD365 ||
                    next?.salesOrderLine?.netTotalD365 === 0
                    ? "0"
                    : next?.salesOrderLine?.netTotalD365.toString()
                ))
          );
        },
        0
      );
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellConversionTotal === null ||
            next.salesOrderLine?.sellConversionTotal === ""
              ? 0
              : parseFloat(next.salesOrderLine?.sellConversionTotal ?? ""))
          );
        },
        0
      );
      const serviceFee = this.serviceFeeFromD365 * sellTotal;
      this.netGp = sellTotal - netTotal - serviceFee;
      this.calculateNetProfitPercentageAfterConvert(this.netGp, sellTotal);
      this.calculateCommissionAfterConvert(this.netGp);
    }
  }

  calculateSubtotalCreditForNonUS() {
    const sellTotal = this.salesOrderLine.reduce(
      (prev: number, next: SaleOrderLineAddressDto) => {
        return (
          prev +
          (next.salesOrderLine?.sellConversionTotal === null ||
          next.salesOrderLine?.sellConversionTotal === ""
            ? 0
            : parseFloat(next.salesOrderLine?.sellConversionTotal ?? ""))
        );
      },
      0
    );
    this.subtotalForCreditLimitCheck = sellTotal;
  }

  calculateNet() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ??
                    "0"
                )
              : parseFloat(next?.salesOrderLine?.netTotalD365.toString() ?? ""))
          );
        },
        0
      );
      this.net = total.toString();
      this.calculateSubtotalsAndNet();
    }
  }

  calculateNetGp() {
    if (this.salesOrderLine.length > 0) {
      const netTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ?? ""
                )
              : parseFloat(next?.salesOrderLine?.netTotalD365.toString() ?? ""))
          );
        },
        0
      );
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365)
              : 0)
          );
        },
        0
      );
      const serviceFee = this.serviceFeeFromD365 * sellTotal;
      this.netGp = sellTotal - netTotal - serviceFee;
      this.calculateNetProfitPercentage(this.netGp, sellTotal);
      this.calculateCommission(this.netGp);
    }
  }

  calculateSubtotalCreditForUS() {
    const sellTotal = this.salesOrderLine.reduce(
      (prev: number, next: SaleOrderLineAddressDto) => {
        return (
          prev +
          (next.salesOrderLine?.sellTotalD365
            ? parseFloat(next.salesOrderLine?.sellTotalD365)
            : 0)
        );
      },
      0
    );
    this.subtotalForCreditLimitCheck = sellTotal;
  }

  calculateNetProfitPercentageAfterConvert(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / sellTotal) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  calculateCommissionAfterConvert(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  calculateSubTotal() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine?.sellTotalD365)
              : 0)
          );
        },
        0
      );
      this.subTotal = total.toString();

      this.calculateOrderTotal();
      this.calculateSubtotalsAndNet();
    }
  }

  calculateSumOfSellTotal() {
    if (this.salesOrderLine.length > 0) {
      const sumOfSellTotal = this.salesOrderLine.reduce(
        (prev: number, next: SaleOrderLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellD365
              ? parseFloat(next.salesOrderLine?.sellD365.toString())
              : 0)
          );
        },
        0
      );
      this.sumOfSellTotal = sumOfSellTotal;
    }
  }

  isSaleOrderLinesConfirm() {
    if (this.salesOrderLine.length > 0) {
      const index = this.salesOrderLine.find(
        x => x.salesOrderLine?.lineRecIdD365 !== null
      );

      if (index) {
        this.isSaleOrderLineSync = this.salesOrderLine.filter(
          x => x.salesOrderLine?.status === 1 && x.salesOrderLine?.isActive
        );
      } else {
        this.isSaleOrderLineSync = this.salesOrderLine.filter(
          (a: SaleOrderLineAddressDto) =>
            (a.salesOrderLine?.status == 1 || a.salesOrderLine?.status == 2) &&
            a.salesOrderLine.isActive
        );
      }

      if (this.isSaleOrderLineSync.length) {
        this.isSaleOrderLineConfirmStatus = true;
      } else {
        this.isSaleOrderLineConfirmStatus = false;
      }
    }
  }

  calculateOrderTotal() {
    const total = this.subTotal + this.estimatedTax + this.estimatedFreight;
    this.orderTotal = parseFloat(total);
  }

  calculateNetProfitPercentage(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / sellTotal) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  calculateCommission(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  callgetPurchaseOrderId(vendorId: string) {
    if (vendorId) {
      this.getPurchaseOrderId(this.saleOrderId, vendorId);
    }
  }

  getPurchaseOrderId(saleOrderId: string, directDeliveryVendor: string) {
    const purchaseOrder: GetExtisingPOIdRequest = {
      SaleOrderId: saleOrderId,
      DirectDeliveryVendor: directDeliveryVendor,
    };

    this._orderSummaryService
      .GetExtisingPOId(purchaseOrder)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            if (res.data.PurchaseOrderIds) {
              this.purchaseOrderIdList = res.data.PurchaseOrderIds;
            }
          }
        },
      });
  }

  IsUserBlockedFromEdit() {
    this._orderSummaryService
      .IsUserBlockedFromEdit(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.userBlockedFromEdit = res.data;
        },
        error: () => {
          this.userBlockedFromEdit = false;
        },
      });
  }

  getAllReleaseProduct() {
    this._orderSummaryService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            x => x.itemNumberD365 != "Misc"
          );
        },
      });
  }

  getSaleOrderHeaderData(getloaderStatus: boolean) {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._orderSummaryService
        .getSaleOrderHeaderData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (!this.saleOrderModalStatus) {
              this._loaderService.setLoaderState(false);
            }
            const odataFilter = `?$filter=ID eq '${this.saleOrderId}' or ID eq '${res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365}'`;
            this._orderSummaryService
              .GetJNIDeletedRecordsFilter(odataFilter)
              .subscribe();
            if (res.data) {
              if (res?.data?.salesOrderHeader) {
                this.salesOrderHeaderData = res.data.salesOrderHeader;
              }

              if (this.salesOrderHeaderData?.salesOrderHeader?.feeCharges) {
                this.serviceFeeFromD365 =
                  this.salesOrderHeaderData.salesOrderHeader.feeCharges /
                  100; /*As per the ticket need to divide the service fee by 100 #12953 */
              }

              if (res.data.salesOrderHeader?.address) {
                this.headerAddress = res?.data?.salesOrderHeader?.address;
              }
              if (res.data.salesOrderHeader?.salesOrderHeader) {
                // this.patchValuesInSaleOrderHeader(
                //   res.data.salesOrderHeader.salesOrderHeader
                // );
                // this.patchValuesInInvoiceEmail(res.data.invoiceEmail || []);
                // this.patchValueInDeliveryName(
                //   res.data.salesOrderHeader.salesOrderHeader.deliveryNameD365 ||
                //     ''
                // );
                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                ) {
                  this.getAvailableCredit(
                    res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                  );
                  // this.getCustomerDetail(
                  //   res.data.salesOrderHeader.salesOrderHeader.customerIdD365
                  // );
                  // this.isCustomerPOFieldRequired(
                  //   res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                  // );
                }
                this.getSellCurrencyConversion(
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.foreignCurrencyD365 ?? ""
                );
                this.getHeaderCalculation();
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.salesOrderStatusD365
                ) {
                  this.salesOrderStatusD365 =
                    res.data.salesOrderHeader.salesOrderHeader.salesOrderStatusD365;
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.approvalStatusD365
                ) {
                  this.approvalStatusD365 =
                    res.data.salesOrderHeader.salesOrderHeader.approvalStatusD365;
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.methodOfPaymentD365
                ) {
                  this.applyFeeCardStatus =
                    res.data.salesOrderHeader.salesOrderHeader.methodOfPaymentD365;
                }

                if (res.data.salesOrderHeader?.salesOrderHeader?.shipDateD365) {
                  // const shipDate =
                  //   res.data?.salesOrderHeader?.salesOrderHeader?.shipDateD365;
                  // this.shipDate = shipDate;
                  const shipDate = new Date(
                    res.data?.salesOrderHeader?.salesOrderHeader?.shipDateD365
                  );
                  this.shipDate =
                    this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";

                  this.inHandDateCurrentdate = new Date(this.shipDate);
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
                ) {
                  // const inHandDate =
                  //   res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365;
                  // this.inHandDate = inHandDate;
                  const inHandDate = new Date(
                    res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
                  );
                  this.inHandDate =
                    this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365
                ) {
                  this.estimatedTax =
                    res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365;
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.recommendedTaxD365
                ) {
                  this.recommendedTax =
                    res.data.salesOrderHeader?.salesOrderHeader?.recommendedTaxD365;
                }
                if (
                  res.data.salesOrderHeader?.salesOrderHeader
                    ?.estimatedFreightD365
                ) {
                  this.estimatedFreight =
                    res.data.salesOrderHeader?.salesOrderHeader?.estimatedFreightD365;
                  this.calculateOrderTotal();
                }

                if (
                  res.data.salesOrderHeader?.salesOrderHeader.orderTotalD365
                ) {
                  this.orderTotalD365 =
                    res.data.salesOrderHeader?.salesOrderHeader?.orderTotalD365;
                }
              }
              this.saleOrderData.salesOrderHeader = res?.data?.salesOrderHeader;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getAvailableCredit(accountNumber: string) {
    this._clientDetailsService
      .getAvailableCredit(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getAvailableCreditBtnStatus = true;
          if (res?.status?.toLowerCase() != "success") {
            this.avaiableCredit = 0;
          } else {
            this.avaiableCredit = res?.data?.availableCredit;
          }
        },
        error: () => {
          this.getAvailableCreditBtnStatus = true;
          this.avaiableCredit = 0;
        },
      });
  }

  getSellCurrencyConversion(currency: string) {
    this.foreignCurrency = currency;
    this.showSmallLoader = true;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }
  getCdiSharePointPdf() {
    this._cdiSummaryService
      .getCDISharePointPdf(this.documentIDD365)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() != "success") {
            this._toastrService.error(
              "Error",
              res.message || "Failed To Fetch the Cdi Sharepoint pdf"
            );
            return;
          } else {
            this.poJournalPdf = res.data;
          }
        },
      });
  }

  netAndSubtotalChanged() {
    this.calculateNetAfterCurrencyConvert();
    this.calculateNet();
    this.calculateSubTotal();
  }

  calculateSubtotalsAndNet() {
    if (this.invoiceEmailListing?.length) {
      // this.invoiceEmailListing[0].jniSubTotal = (
      //   parseFloat(this.net || "0") +
      //   this.tax +
      //   this.freight
      // ).toString();
      // this.invoiceEmailListing[0].vendorSubTotal = (
      //   parseFloat(this.net || "0") + this.unmatched
      // ).toString();
      // this.invoiceEmailListing[0].diff =
      //   parseFloat(this.net || "0") +
      //   this.unmatched -
      //   (parseFloat(this.net || "0") + this.tax + this.freight);
    }
  }

  closeModal() {
    this.closeEvent.emit();
  }

  quickNoteChangeEvent(obj = "") {
    this.quickQuoteValue = obj;
  }
  submitQuickNoteAPIEvent() {
    this.cdiNotes.onQuickQuote();
  }

  quickNoteMandatoryEvent(mandatory: boolean) {
    this.cdiNotes.quickNotesMandatory = mandatory;
  }
}
